ceregoCommon.service("WindowHelper", ['$window', ($window) ->
  service =
    inIframe: ->
      try
        $window.self != $window.top
      catch e
        true # Cross-domain exception could be thrown when in an iframe and trying to access $window.top
])
